import { useEffect, useState } from 'react';

type SpecialKeys = {
  isShiftKey?: boolean;
  isCtrlKey?: boolean;
  isAltKey?: boolean;
};

const useKeyPress = (targetKey: string, specialKeys?: SpecialKeys): boolean => {
  // State for keeping track of whether key is pressed
  const [keyPressed, setKeyPressed] = useState(false);

  const handleKeyPressed = (event: KeyboardEvent, val: boolean) => {
    const { key, shiftKey, ctrlKey, altKey } = event;
    const { isShiftKey, isCtrlKey, isAltKey } = specialKeys || {};
    if (key === targetKey && ((isShiftKey && shiftKey) || !isShiftKey) && ((isCtrlKey && ctrlKey) || !isCtrlKey) && ((isAltKey && altKey) || !isAltKey)) setKeyPressed(val);
  };

  // If pressed key is our target key then set to true
  const downHandler = (event: KeyboardEvent): void => {
    handleKeyPressed(event, true);
  };

  // If released key is our target key then set to false
  const upHandler = (event: KeyboardEvent): void => {
    handleKeyPressed(event, false);
  };

  // Add event listeners
  useEffect(() => {
    window.addEventListener('keydown', downHandler);
    window.addEventListener('keyup', upHandler);
    // Remove event listeners on cleanup
    return () => {
      window.removeEventListener('keydown', downHandler);
      window.removeEventListener('keyup', upHandler);
    };
  }, []); // Empty array ensures that effect is only run on mount and unmount

  return keyPressed;
};

export default useKeyPress;
